import { api } from './api';

export interface TutorCodeDTO {
  id: number;
  code: string;
  maxUses: number | null;
  currentUses: number;
  expiresAt: string | null;
  status: string;
  createdAt: string;
}

export interface TutorCodeGenerateRequest {
  maxUses?: number | null;
  expiresAt?: string | null;
}

export const generateCode = async (
  courseId: number,
  payload: TutorCodeGenerateRequest = {}
): Promise<TutorCodeDTO> => {
  const response = await api.post(`/api/tutor/courses/${courseId}/codes`, payload);
  return response.data.data;
};

export const listCodes = async (courseId: number): Promise<TutorCodeDTO[]> => {
  const response = await api.get(`/api/tutor/courses/${courseId}/codes`);
  return response.data.data;
};

export const deactivateCode = async (courseId: number, codeId: number): Promise<TutorCodeDTO> => {
  const response = await api.patch(`/api/tutor/courses/${courseId}/codes/${codeId}/deactivate`);
  return response.data.data;
};

export const activateCode = async (courseId: number, codeId: number): Promise<TutorCodeDTO> => {
  const response = await api.patch(`/api/tutor/courses/${courseId}/codes/${codeId}/activate`);
  return response.data.data;
};

export const deleteCode = async (courseId: number, codeId: number): Promise<void> => {
  await api.delete(`/api/tutor/courses/${courseId}/codes/${codeId}`);
};
